import { gql } from '@apollo/client'
import { ticketAlertFragment } from './getActiveTicketAlerts'

export const CHANGE_TICKET_ALERTS = gql`
  mutation changeTicketAlerts($input: ChangeTicketAlertsInput!) {
    changeTicketAlerts(input: $input) {
      ticketAlerts {
        ...alert
      }
      errors {
        code
        message
      }
    }
  }
  ${ticketAlertFragment}
`
